const setSessionStorage = (key, value) => {
  // console.log(key, value);
  window.sessionStorage.setItem(key, value);
};

const getSessionStorage = (key) => window.sessionStorage.getItem(key);

const removeItemSessionStorage = (key) => {
  // console.log("Removing:", key);
  window.sessionStorage.removeItem(key);
};

module.exports = { setSessionStorage, getSessionStorage, removeItemSessionStorage };
